const Header = () => {
	return(
		      <footer className="footer">
            <div className="d-sm-flex justify-content-center">
              <span className="float-none text-center d-block mt-1 mt-sm-0 text-center space-x-2">Created by <a href={"https://www.linkedin.com/in/vivek-shah-b65507231/"} target="_blank" rel="noopener noreferrer" className="round-link">
								Vivek
								</a> and <a> </a>
                <a href={"https://www.linkedin.com/in/vrajshah113"} target="_blank" rel="noopener noreferrer">
								 Vraj
								</a>.Copyright ©  2023. All rights reserved.</span>
            </div>
          </footer>
		)

}

export default Header;
